import { Dispatch } from "redux";
import { setAxnAdminCacheRefreshResults, setAxnAdminCacheRefreshing } from "@redux/actions/axn-admin-cache-actions";
import { refreshAxnAdminCacheRequest } from "@requests/management-console/refresh-axn-admin-cache";
import { RefreshResult } from "@idw-types/common";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const refreshAxnAdminCacheReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<RefreshResult>> => {
    dispatch(setAxnAdminCacheRefreshResults(null, null));
    dispatch(setAxnAdminCacheRefreshing(true));
    const { data, error } = await refreshAxnAdminCacheRequest();

    const lastRefreshDate = new Date();

    if (data) {
        dispatch(setAxnAdminCacheRefreshResults(data, lastRefreshDate));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.refreshAxnAdminCache.error.title,
                resources.requests.refreshAxnAdminCache.error.message
            );
        }
        dispatch(setAxnAdminCacheRefreshResults(null, lastRefreshDate));
        return null;
    }
};